<template>
    <div class="chat-top-message">
        <div class="title">置顶消息: </div>
        <div class="content" v-html="content" @click.stop="onClickMessage"> </div>
        <div class="close" title="移除" @click.stop="onClose"><i class="el-icon-close"></i></div>
    </div>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';


export default {
    name: "chatTopMessage",
    components: { HeadImage },
    props: {
        group: {
            type: Object
        },
        groupMembers: {
            type: Array
        },
        msgInfo: {
            type: Object,
            required: true
        },
        headImage: {
            type: String,
            default: ''
        },
        showName: {
            type: String,
            required: true
        }
    },
    data() {
        return {

        }
    },
    methods: {
        onClose() {
            if (this.isOwner || this.isManager) {
                this.removeTopMessage();
            } else {
                this.hideTopMessage();
            }
        },
        onClickMessage() {
            // 定位消息
            this.$emit("locate", this.msgInfo);
        },
        removeTopMessage() {
            this.$confirm('将在当前群聊的所有成员中移除此置顶消息,确认移除？', '移除置顶', {
                confirmButtonText: '移除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: "/group/removeTopMessage/" + this.group.id,
                    method: 'delete'
                })
            });
        },
        hideTopMessage() {
            this.$http({
                url: "/group/hideTopMessage/" + this.group.id,
                method: 'delete'
            })
        }
    },
    computed: {
        content() {
            if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT) {
                return this.$emo.transform(this.$str.html2Escape(this.msgInfo.content), 'emoji-normal');
            }else {
                return this.$msgUtil.previewContent(this.msgInfo)
            }
        },
        isOwner() {
            return this.group.ownerId == this.userStore.userInfo.id;
        },
        isManager(){
			let userId = this.userStore.userInfo.id;
			let m = this.groupMembers.find((m) => m.userId == userId);
			return m && m.isManager;
		}
    }

}
</script>

<style scoped lang="scss">
.chat-top-message {
    margin: 0 2px;
    display: flex;
    background: linear-gradient(135deg, rgba(91, 141, 238, 0.1), rgba(168, 139, 255, 0.08) 60%, rgba(255, 175, 204, 0.06));
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 0.5px solid rgba(91, 141, 238, 0.2);
    box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.6);
    padding: 10px 15px;
    align-items: center;
    border-radius: var(--radius-xs);

    .title {
        font-size: var(--im-font-size-large);
        color: var(--aurora-blue);
        font-weight: 600;
    }

    .content {
        flex: 1;
        font-size: var(--im-font-size-large);
        color: var(--im-text-color-secondary);
        height: 25px;
        word-break: break-all;
        overflow: hidden;
        cursor: pointer;
        line-height: 25px;
        text-align: left;
        margin-left: 10px;
    }

    .close {
        margin-left: 10px;
        width: 30px;
        cursor: pointer;
        color: var(--im-text-color-lighter);
        transition: color 0.18s ease;
        &:hover { color: var(--im-text-color); }
    }
}
</style>